export const REGIONS_RESET_STATE = 'REGIONS_RESET_STATE';
export const REGIONS_CURRENT_ITEM = 'REGIONS_CURRENT_ITEM';

export const REGIONS_REQUEST_LOADING = 'REGIONS_REQUEST_LOADING';
export const REGIONS_REQUEST_SUCCESS = 'REGIONS_REQUEST_SUCCESS';
export const REGIONS_REQUEST_FAILED = 'REGIONS_REQUEST_FAILED';

export const REGIONS_CURRENT_ACTION = 'REGIONS_CURRENT_ACTION';
export const REGIONS_RESET_ACTION = 'REGIONS_RESET_ACTION';